import React from 'react'
import { useTimer } from '@src/hooks/useTimer'

interface TimerProps {
  className?: string
  timestampEnd?: string
  timestampStart?: string
}

function Timer({ className, timestampEnd, timestampStart }: TimerProps) {
  const timerValues = useTimer({ timestampEnd, timestampStart })

  return (
    <div className={className}>
      <span>{timerValues.hours}</span>
      <span>:</span>
      <span>{timerValues.minutes}</span>
      <span>:</span>
      <span>{timerValues.seconds}</span>
    </div>
  )
}

export { Timer }
